module.exports = __webpack_public_path__ + "static/img_1187-14b99e82fc3b908516b3c8616be4b958.webp";